import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"

import _ from 'lodash'
import ogImage from "../../images/posts/65/thumb-landscape.jpg"

const Post65 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>ロゴはいらない。<br></br>
          分かりやすい装飾も、トレンドを誇張するデザインもありません。</p>
          <p>それなのに、なぜか視線が止まり、気づけば「欲しい」と感じてしまう——<br></br>
          THE ROWのバッグには、そんな不思議な引力があります。</p>
          <p>派手さで魅せるのではなく、静かに、確実に、持つ人の価値観を映し出す存在。<br></br>
          今、派手さよりも“本当に良いもの”を選ぶ考え方が支持されている理由は、まさにここにあります。</p>
          <p>本記事では、THE ROWがどのように生まれ、オルセン姉妹が築いてきた“静かなラグジュアリー”の哲学についてご紹介します。</p>
          <p>あわせて、ロゴに頼らず、素材や仕立てで評価されるTHE ROWのバッグが、なぜ今これほどまでに支持されているのか、その理由を紐解いていきます。</p>
          <p>さらに、THE ROWの中でも特に人気の高いバッグ3選「マルゴー」「N/S パークトート」「ハーフムーン」を厳選して解説します。サイズ感や印象、使えるシーンが一目で分かる比較表とともに、日常に取り入れやすいコーディネート提案までお届けします。</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2 style={{color: "#0a9186"}}>目次</h2>
        <p>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>1 |</span>&nbsp;&nbsp;なぜか惹かれる、その答えはTHE ROWにある</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>2 |</span>&nbsp;&nbsp;THE ROWを形づくる、オルセン姉妹の美意識</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec3" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>3 |</span>&nbsp;&nbsp;価値観の変化にフィットする、THE ROWのバッグ</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec4" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>4 |</span>&nbsp;&nbsp;THE ROW人気3選｜まず選ぶなら、この3モデル</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec5" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;マルゴー10｜きちんと感で選ばれる定番バッグ</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec6" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ミディアム N/S パークトート｜毎日使える上質トートバッグ</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec7" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ハーフムーンバッグ｜大人の抜け感をつくる人気モデル</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec8" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>5 |</span>&nbsp;&nbsp;バッグで変わる、大人の一日。THE ROWのシーン別スタイル</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec9" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;マルゴー10｜フォーマル寄りのシーンや、節目の日に選びたい一生もの</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec10" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ミディアム N/S パークトート｜通勤から外出まで、動きの多い一日に</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec11" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ハーフムーンバッグ｜週末のランチ、買い物、気負わない外出に</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec12" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>6 |</span>&nbsp;&nbsp;まとめ：静かに、でも確かに選ばれる理由</ScrollLink>
          </div>
        </p>
      </div>
      <section name="sec1" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/65/1.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>なぜか惹かれる、その答えはTHE ROWにある</h2>
        </div>
        <p>THE ROWの魅力は、一言でいえば「語らない美しさ」です。<br></br>
        ブランドロゴを前面に押し出すことなく、フォルム・素材・仕立てだけで完成度を示す。その姿勢こそが、クワイエットラグジュアリーの本質といえるでしょう。</p>
        <p>上質なレザーは、触れた瞬間に違いが分かるほどしなやかです。<br></br>
        直線と曲線のバランスは計算され尽くしており、流行に左右されない普遍性を備えています。</p>
        <p>だからこそTHE ROWのバッグは、「今っぽい」ではなく、「いつ持っても素敵」であり続けます。<br></br>
        また、ミニマルなデザインはコーディネートを選びません。<br></br>
        カジュアルにも、きれいめにも、年齢を重ねたスタイルにも自然に馴染みます。</p>
        <p>“バッグが主役”になるのではなく、持つ人自身を引き立てる。<br></br>
        そのバランス感覚が、THE ROWが長く信頼されている理由です。</p>
      </section>
      <section name="sec2" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/65/2.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>THE ROWを形づくる、オルセン姉妹の美意識</h2>
        </div>
        <p>THE ROWを語るうえで欠かせないのが、創設者であるアシュリー・オルセン（Ashley Olsen）とメアリー・ケイト・オルセン（Mary-Kate Olsen）姉妹の存在です。</p>
        <p>THE ROWは、2006年にアメリカ・ニューヨークで設立されました。<br></br>
        ブランド名は、ロンドンのサヴィル・ロウ（Savile Row）に由来し、ビスポークテーラーが追求する最高級のファブリック、繊細なディテール、そして完璧なフィットへの敬意が込められています。<br></br>
        元々は世界的な俳優として注目を集めてきた二人ですが、ファッションにおいては、常に「目立つこと」よりも「本質」を選んできました。</p>
        <p>トレンドを追いかけるのではなく、<br></br>
        一着一着の素材、シルエット、着心地と丁寧に向き合う。<br></br>
        その姿勢は、THE ROWの服づくりだけでなく、バッグのデザインにも色濃く反映されています。</p>
        <p>彼女たちが目指しているのは、<br></br>
        “誰かに見せるためのラグジュアリー”ではなく、<br></br>
        着る人・持つ人自身が心地よくいられるラグジュアリー。</p>
        <p>だからこそ、THE ROWのバッグはデザインを主張しすぎることなく、年齢やライフステージを問わず、静かに寄り添います。オルセン姉妹の価値観そのものが、ブランドの「静かな強さ」として、今も変わらず息づいているのです。</p>
      </section>
      <section name="sec3" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/65/3.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>価値観の変化にフィットする、THE ROWのバッグ</h2>
        </div>
        <p>THE ROWは、特定の年齢層に向けたブランドではなく、ライフステージの変化に寄り添う存在です。そのため、世代ごとに異なる理由で選ばれながら、幅広い年齢層から支持を集めています。</p>
        <p>なお、THE ROWのバッグは製造時期によってロゴ仕様が異なり、旧モデルでは箔押し、新しいモデルでは型押しが採用されています。</p>
        <p>この変化は、ロゴを目立たせるよりも、バッグそのものの完成度や佇まいで価値を伝えるという、ブランドの姿勢がより明確になった表れともいえます。</p>
        <div className="img-two-cloumn mt4">
          <figure className="img-small">
            <StaticImage src="../../images/posts/65/4.jpg" alt=""/>
            <span className="text-center">旧ロゴモデル：箔押し</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/65/5.jpg" alt=""/>
            <span className="text-center">新ロゴモデル：型押し</span>
          </figure>
        </div>
        <p className="mt4">20〜30代にとっては、ロゴに頼らない感度の高さや、トレンドを追いすぎない姿勢が魅力です。<br></br>
        「そろそろ本当に良いバッグを持ちたい」と感じ始めたタイミングで、選ばれることが多いブランドといえるでしょう。</p>
        <div className="img-two-cloumn mt4">
          <figure className="img-small">
            <StaticImage src="../../images/posts/65/6.jpg" alt=""/>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/65/7.jpg" alt=""/>
          </figure>
        </div>
        <p className="mt4">30代以降にとっては、<br></br>
        上質で落ち着いた印象、仕事にも私生活にも使える汎用性が支持されています。<br></br>
        「良いものを、長く使いたい」という価値観に、THE ROWは静かに寄り添ってくれます。<br></br>
        年齢を重ねるほど、ブランドを“見せる”必要はなくなります。<br></br>
        THE ROWは、そんな価値観の変化にも自然にフィットする存在です。</p>
      </section>
      <section name="sec4" className="section-content">
        <div className="img-three-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/65/8.jpg" alt=""/>
            <span className="text-center">MARGAUX 10</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/65/9.jpg" alt=""/>
            <span className="text-center">MEDIUM N/S PARK TOTE</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/65/10.jpg" alt=""/>
            <span className="text-center">HALF MOON</span>
          </figure>
        </div>
        <div className="table-rounded-bg">
          <div className="table-wrap">
            <table className="table-rounded">
              <thead>
                <tr>
                  <th></th>
                  <th>サイズ (cm)</th>
                  <th>おすすめシーン</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>MARGAUX 10</th>
                  <td>W20 × H14 × D11</td>
                  <td>
                    <p>仕事・きれいめ<br></br>
                    きちんと感を重視するなら「マルゴー」</p>
                  </td>
                </tr>
                <tr>
                  <th>MEDIUM<br></br>N/S PARK TOTE</th>
                  <td>W17 × H27 × D15</td>
                  <td>
                    <p>デイリー・移動が多い日<br></br>
                    実用性と軽やかさなら「パークトート」</p>
                  </td>
                </tr>
                <tr>
                  <th>HALF MOON</th>
                  <td>W19 × H18 × D6</td>
                  <td>
                    <p>休日・カジュアル<br></br>
                    抜け感と女性らしさなら「ハーフムーン」</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="mt8">
          <h2>THE ROW人気3選｜まず選ぶなら、この3モデル</h2>
        </div>
        <p>数あるラインナップの中から、特に人気の高い3モデルをピックアップしました。<br></br>
        今回比較した マルゴー10、ミディアム N/S パークトート、ハーフムーンバッグ は、いずれもTHE ROWを代表する人気モデルですが、「用途」と「なりたい印象」 によって最適な選択肢は大きく異なります。</p>
        <div name="sec5" className="mt8">
          <h3>◆ マルゴー10｜きちんと感で選ばれる定番バッグ</h3>
          <div className="img-three-cloumn">
            <figure className="img-small">
              <StaticImage src="../../images/posts/65/11.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/65/12.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/65/13.jpg" alt=""/>
            </figure>
          </div>
          <p className="text-center">W20 × H14 × D11 cm</p>
          <p className="mt4">THE ROWの人気を象徴するバッグのひとつが、マルゴー10です。<br></br>
          クラシックでありながら、上質さがひと目で伝わるデザインは、まさにブランド哲学の体現といえる存在です。滑らかでいながら程よい表情のあるグレインドカーフレザーを使用しています。この素材は傷が目立ちにくく、日常使いでも経年変化を楽しみながら育てられる質感です。イタリア製のレザーは触れた瞬間に違いが分かるほど上質で、使い込むほどに自然なツヤと味わいが増していきます。</p>
          <figure className="mt8">
            <StaticImage src="../../images/posts/65/14.jpg" alt=""/>
          </figure>
          <p>トップハンドル＋ショルダーストラップ付きの2WAY仕様です。<br></br>
          ハンドバッグとして持つだけでなく、ショルダーで 両手を自由にした使い方も可能です。<br></br>
          内側は仕切りのないスムーズな空間になっており、日常の必需品（財布・スマホ・ミニポーチなど）をすっきり収められるサイズ感です。</p>
        </div>
        <div name="sec6" className="mt8">
          <h3>◆ ミディアム N/S パークトート｜毎日使える上質トートバッグ</h3>
          <div className="img-three-cloumn">
            <figure className="img-small">
              <StaticImage src="../../images/posts/65/15.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/65/16.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/65/17.jpg" alt=""/>
            </figure>
          </div>
          <p className="text-center">W17 × H27 × D15 cm</p>
          <p className="mt4">ミディアム N/S パークトート は、“都会のシーンに寄り添うミニマルで上質なトートバッグ” として人気のモデルです。無駄な装飾やロゴをあえて排したデザインでありながら、持った瞬間に「質の良さ」が伝わる佇まいが、このバッグの大きな魅力です。一見とてもシンプルですが、素材の美しさやフォルムの完成度によって、自然と視線を引き寄せます。</p>
          <figure className="mt8">
            <StaticImage src="../../images/posts/65/18.jpg" alt=""/>
          </figure>
          <p>幅・高さ・奥行きのバランスがとれた デイリーサイズです。<br></br>
          財布・スマホ・手帳・ポーチなどをしっかり収納できますが、ごちゃごちゃせずにすっきり持てる軽やかさも魅力です。大きすぎず、小さすぎず、日常のあらゆるシーンに対応します。</p>
          <div className="img-two-cloumn mt8">
            <figure className="img-small">
              <StaticImage src="../../images/posts/65/19.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/65/20.jpg" alt=""/>
            </figure>
          </div>
          <p>パークトートは一見シンプルですが、機能性もきちんと考えられています。<br></br>
          内部にはレザーの結び留め（タイ）で中身をやさしく固定でき、底面はやや四角く、整理しやすい構造です。無駄のない設計でありながら、日常の動きにフィットする実用性があります。</p>
        </div>
        <div name="sec7" className="mt8">
          <h3>◆ ハーフムーンバッグ｜大人の抜け感をつくる人気モデル</h3>
          <div className="img-three-cloumn">
            <figure className="img-small">
              <StaticImage src="../../images/posts/65/21.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/65/22.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/65/23.jpg" alt=""/>
            </figure>
          </div>
          <p className="text-center">W19 × H18 × D6 cm</p>
          <p className="mt4">ハーフムーンバッグは、「曲線×ミニマル」の美学を体現する定番モデルです。<br></br>
          その名前が示す通り、半月（ハーフムーン）のようなやわらかなシルエットがひと目で印象に残るデザインです。ハーフムーンバッグ大きな特徴は、丸みを帯びたフォルムです。肩に掛けたときに身体のラインに自然になじむ設計で、見た目の美しさだけでなく持ち心地の良さも追求されています。</p>
          <div className="img-two-cloumn mt8">
            <figure className="img-small">
              <StaticImage src="../../images/posts/65/24.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/65/25.jpg" alt=""/>
            </figure>
          </div>
          <p>見た目はシンプルでありながら、日常使いに適した機能性もしっかりと備えています。トップにはジッパーが配されており、中身を安心して収納できる仕様。内側にはスエードの裏地が施され、大切な持ち物をやさしく包み込みます。サイズ感も絶妙で、財布やスマートフォン、カードケースなど、必要最低限のアイテムを無理なくすっきりと収めることができます。</p>
        </div>
        <figure className="mt8">
          <StaticImage src="../../images/posts/65/26.jpg" alt=""/>
        </figure>
        <p>派手さに頼らず、それでいて実用性をきちんと確保する。このバランスこそが、THE ROWが一貫して大切にしている設計思想をよく表しています。</p>
         <figure className="mt8">
          <StaticImage src="../../images/posts/65/27.jpg" alt=""/>
        </figure>
      </section>
      <section name="sec8" className="section-content">
        <div>
          <h2>バッグで変わる、大人の一日。THE ROWのシーン別スタイル</h2>
        </div>
        <p>寒さの中に、少しずつ春の気配を感じ始める2月。</p>
        <p>外出の目的も、フォーマルな場から日常、週末のお出かけまで幅が広がる時期だからこそ、<br></br>
        「どんなシーンで、どんなバッグを選ぶか」が、大人のスタイルを左右します。</p>
        <p>そこで今回は、THE ROWの人気3モデルを軸に、シチュエーションごとに似合うコーディネートをご紹介します。</p>
        <p>バッグを主役にしすぎず、装いに自然な品格と抜け感を添える——</p>
        <p>THE ROWならではのバランスを、具体的なスタイリングとともにご紹介します。</p>
        <div name="sec9" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/65/28.jpg" alt=""/>
          </figure>
          <h3>◆ マルゴー10｜フォーマル寄りのシーンや、節目の日に選びたい一生もの</h3>
          <p>マルゴー10は、THE ROWの中でも最もフォーマル寄りの佇まいを持つバッグです。<br></br>
          構築的で端正なフォルムは、装いに自然な緊張感と品格をもたらします。</p>
          <p>ツイードベストとフリルブラウスを主役に、ネイビーのパンツで全体をすっきりとまとめています。<br></br>
          程よく華やぎのあるトップスに対し、ブラックのマルゴー10を合わせることで、甘さを抑えた大人のフォーマルスタイルが完成します。卒業式・入学式、式典、改まった会食など、写真に残るシーンでも安心して選べるのがこのバッグです。</p>
          <p>ロゴに頼らないミニマルなデザインだからこそ、コーディネートの邪魔をせず、年齢や立場を問わず自然になじみます。</p>
        </div>
        <div name="sec10" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/65/29.jpg" alt=""/>
          </figure>
          <h3>◆ ミディアム N/S パークトート｜通勤から外出まで、動きの多い一日に</h3>
          <p>ミディアム N/S パークトートは、日常の実用性と大人の美しさを静かに両立するTHE ROWらしいトートバッグです。縦にすっと伸びるフォルムは、荷物をしっかり収納しながらも、装い全体をスマートに見せてくれるのが魅力です。</p>
          <p>淡いトーンのオールインワンにトレンチコートを重ねたきれいめスタイルに合わせ、知的で落ち着いた印象に仕上げています。パークトートが、コーディネートに自然になじみつつ、全体を引き締める役割を果たします。</p>
          <p>書類やポーチなどを無理なく収められる容量があり、通勤はもちろん、打ち合わせ、仕事終わりの外出まで一日を通して頼れる存在です。アウターを着たままでも持ちやすく、荷物が増えがちな日でも安心感があります。</p>
        </div>
        <div name="sec11" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/65/30.jpg" alt=""/>
          </figure>
          <h3>◆ ハーフムーンバッグ｜週末のランチ、買い物、気負わない外出に</h3>
          <p>ハーフムーンバッグは、オフの日の装いに自然な抜け感を与えてくれる存在です。</p>
          <p>スウェットのセットアップに淡いトーンのロングコートを重ね、リラックス感の中にきちんと感を添えています。カジュアルなアイテムが中心でも、ハーフムーンバッグのなめらかなレザーと曲線的なフォルムが加わることで、全体がラフになりすぎず、大人らしいバランスになります。</p>
          <p>半月型のシルエットは身体のラインに自然になじみ、肩掛けしたときもストレスフリーです。<br></br>
          近所でのランチや買い物、友人とのカフェ時間など、「少しだけおしゃれしたい」日に、気負わず持てる上質さが魅力です。</p>
        </div>
      </section>
      <section name="sec12" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/65/31.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>まとめ：静かに、でも確かに選ばれる理由</h2>
        </div>
        <p>THE ROWのバッグは、ひと目で分かる派手さやトレンド感を主張するものではありません。<br></br>
        それでも多くの人に選ばれ続けているのは、日常の中で「使うほどに納得できる完成度」を備えているからです。</p>
        <p>フォーマルな場面でも迷わず手に取れるマルゴー。<br></br>
        荷物が増えても、美しく持てるN/S パークトート。<br></br>
        肩の力を抜いた装いに、自然な品格を添えるハーフムーンバッグ。</p>
        <p>それぞれに役割は異なりますが、共通しているのは持つ人のスタイルを邪魔せず、暮らしに静かに寄り添うこと。<br></br>
        仕事、外出、セレモニー、そして季節の変わり目。<br></br>
        シーンが移ろっても、装いが変わっても、違和感なく使い続けられる。</p>
        <p>そんな“長く信頼できるバッグ”を探している人にとって、THE ROWは自然な選択肢といえるでしょう。</p>
        <p className="mt4"><span className="text-border-bottom">THE ROWのバッグが気になった方はこちら</span></p>
        <p>価格が高く、簡単には手に取りにくいTHE ROWのバッグ。<br></br>
        「試してみたいけれど、買うには勇気がいる」──そんな方も多いのではないでしょうか。<br></br>
        また、「近くに取り扱い店舗がない」「デパートやブティックは少し緊張してしまう」「実際に自分の服や生活に合うか分からない」といった理由から、気になりつつも一歩踏み出せない方も少なくありません。</p>
        <p>そんな方におすすめなのが、ブランドバッグシェアリングサービス「ラクサス」です。<br></br>
        アプリで簡単に注文でき、自宅にいながら憧れのTHE ROWのバッグを実際に使って体験できます。</p>
        <div className="border"></div>
        <p>📱憧れを日常に──ラクサスでTHE ROWを体験しよう！</p>     
        <Link to="https://laxus.co/app/pc/bags/therow" className="view-all-button">THE ROWのバッグはこちら</Link>
      </section>
    </section>
    </div>
  </div>
</Layout>
)}

export default Post65

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 65}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`